import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LatinExt from "./PatrickHand-Regular-LDI1apSQOAYtSuYWp8ZhfYe8UcLLubg58xGL.woff2";
import Latin from "./PatrickHand-Regular-LDI1apSQOAYtSuYWp8ZhfYe8UMLLubg58xGL.woff2";

export const PatrickHandFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LatinExt,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
    },
  },
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
